import Vue from "vue";
import App from "./App.vue";
import Axios from "axios";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import "./registerServiceWorker";
import config from "./config";
import cache from "./cache";
import lawyerly from "./lawyerly";
import ionic from "./ionic";
import { fetch as fetchPolyfill } from 'whatwg-fetch/fetch';

const cordova = window.cordova;

const isWeb = cordova === undefined;

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

sync(store, router, {
  moduleName: "route"
});

router.beforeEach((to, from, next) => {
  let layout;
  let requiresAuth;
  to.matched.forEach(record => {
    if (record.meta) {
      if (record.meta.layout) {
        layout = record.meta.layout;
      }
      if (record.meta.requiresAuth) {
        requiresAuth = true;
      }
    }
  });

  if (layout) {
    store.commit("ui/setLayout", layout)
  }

  if (requiresAuth) {
    if (!store.getters['user/isAuthenticated']) {
      next('/profile/login')
      return
    }
  }

  store.commit("ui/setMoreHeaderButtons", []);
  store.commit("ui/setHeaderTitle", "");

  next();
});

Vue.directive("ion-model", {
  bind: function (el, binding, vnode) {
    // //console.log(el);
    // console.log(binding);
    // console.log(vnode);
    var target = "value";
    if (["ION-TOGGLE", "ION-CHECKBOX"].includes(el.tagName)) {
      target = "checked";
    }

    vnode.context.$watch(binding.expression, function (n, o) {
      el[target] = n;
    });

    el[target] = binding.value;
    el.addEventListener("ionChange", function (e) {
      vnode.context[binding.expression] = e.detail[target];
    });
  }
});

const loadApp = () => {
  new Vue({
    router,
    store,
    render: h => h(App),

    mixins: [ionic.mixins, lawyerly.mixins],

    methods: {
      async whoAmI() {
        await this.$http.get(this.$config.api.url + "/auth/me")
          .then(me => {
            const user = me.data;
            this.$store.commit("user/setUser", user);
            this.checkAnnotations(user);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.commit("user/setUser", null);

                import(/* webpackChunkName: "logout" */'@/firebase')
                  .then($firebase => {
                    $firebase.firebase.auth().signOut();
                  });

                this.$ionic.showToast(
                  "Session expired. You have been logged out.",
                  {
                    duration: 3500,
                    position: "bottom"
                  }
                );

                this.$router.replace("/profile/login");
              }
              console.log(error.response);
            }
          });
      },
      checkAnnotations(user) {
        if (user.subscription.status == 'active') {
          return;
        }

        if (this.$store.state.user['notice_shown']) {
          const result = differenceInDays(
            new Date(),
            new Date(this.$store.state.user['notice_shown'])
          );

          if (result < 1) {
            return;
          }
        }

        if ((300 - user.annotations) > 0) {
          this.$ionic.showAlert(`You can still digest <b>${300 - user.annotations}</b> cases under the Free Lawyerly subscription. Subscribe now to Lawyerly Premium to enjoy unlimited case digests.`,
            {
              cssClass: "medium-width-alert",
              header: "Keep Going...",
              buttons: [{ text: "Subscribe", handler: () => (this.$router.push("/subscribe")) }, { text: "No, thanks.", handler: () => { this.$store.commit("user/setNoticeShown", new Date) } }]
            }
          );
        } else {
          this.$ionic.showAlert(`insert text here. Subscribe now to Lawyerly Premium to enjoy unlimited case digests.`,
            {
              cssClass: "medium-width-alert",
              header: "Subscribe Now",
              buttons: [{ text: "Subscribe", handler: () => (this.$router.push("/subscribe")) }, { text: "No, thanks.", handler: () => { } }]
            }
          );
        }
      }
    },

    beforeCreate() {

      window.fetch = fetchPolyfill;
      window.$app = this;

      Vue.prototype.$http = Axios;
      Vue.prototype.$config = config;
      Vue.prototype.$cache = cache;
      Vue.prototype.$lawyerly = lawyerly;
      Vue.prototype.$ionic = ionic;
      Vue.prototype.$isWeb = isWeb;

      // Handle the back button
      if (!isWeb) {
        function onBackKeyDown() {
          router.go(-1);
        }
        document.addEventListener("backbutton", onBackKeyDown, false);
      }

    },

    created() {

      document.getElementById("init-loader").remove();
      var token = this.$store.state.user.token;
      if (token) {
        this.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
        this.whoAmI();
      } else {
        if (this.$store.state.user.user.email) {
          this.$store.commit("user/setUser", null);
        }
      }
    }
  }).$mount("#app");
}

if (isWeb) {
  loadApp();
} else {
  document.addEventListener("deviceready", loadApp, false);
}
